import React from 'react';
import Loader from 'react-loader-spinner';
import { Button } from 'reactstrap';

const SubmitButtons = ({ edit, isLoading, onSubmit, onCancel }) => {
  return (
    <>
      {isLoading ? (
        <Button color="secondary" className="rounded-right w-100 my-2" disabled>
          <Loader type="Oval" color="white" height={18} width="100%" />
        </Button>
      ) : (
        <Button
          color="success"
          className="rounded-right w-100 my-2"
          onClick={onSubmit}
          style={{ backgroundColor: '#53b59f' }}
        >
          {edit ? 'Edit' : 'Create'}
        </Button>
      )}
      <Button
        color="danger"
        className="rounded-right w-100 my-2"
        onClick={onCancel}
      >
        Cancel
      </Button>
    </>
  );
};

export default SubmitButtons;
